// 403 Not Authorized page.
//
// Rendered by ProtectedRoute when a signed-in user is denied a route and there
// is no other page to send them to. The common denial path is a redirect to
// the user's own landing page (a portal door, /portal); this surface is the
// fallback for the account that has NO such home — e.g. a non-admin whose
// default landing is /dashboard, the admin-only route being guarded — so the
// guard never redirects a user back onto the route that just refused them.

import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function NotAuthorizedPage() {
  const { logout } = useAuth();
  return (
    <div
      role="main"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '2rem',
        textAlign: 'center',
        color: '#1f2937',
      }}
    >
      <p style={{ fontSize: '3.5rem', fontWeight: 700, color: '#0B4FA3', margin: 0, lineHeight: 1 }}>
        403
      </p>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 600, margin: '0.75rem 0 0.25rem' }}>
        You don’t have access to this page
      </h1>
      <p style={{ color: '#6b7280', maxWidth: 420, margin: '0 0 1.5rem' }}>
        This area is for administrators. If you think you should have access, ask an
        administrator to update your account.
      </p>
      <div style={{ display: 'flex', gap: '0.75rem' }}>
        <Link
          to="/portal"
          style={{
            display: 'inline-block',
            padding: '0.5rem 1.25rem',
            background: '#0B4FA3',
            color: '#ffffff',
            borderRadius: 6,
            textDecoration: 'none',
            fontWeight: 500,
          }}
        >
          Go to the portal
        </Link>
        <button
          type="button"
          onClick={() => void logout()}
          style={{
            padding: '0.5rem 1.25rem',
            background: '#ffffff',
            color: '#0B4FA3',
            border: '1px solid #0B4FA3',
            borderRadius: 6,
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
